import React, { useState, useEffect, Children } from "react";
import { EmployeeDataVM, FeedBackVM } from "../../Models/ViewModels";
import {
  Table,
  Pagination,
  Stack,
  Avatar,
  Input,
  Button,
  DateRangePicker,
  DatePicker,
} from "rsuite";
import * as ProfileDB from "../../Services/KRAApprovalDB";
import { PageHeader } from "../../SharedComponents/PageHeader";
import "./KRAEntryScreen.css";
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { CustomTableCell } from "../../SharedComponents/CustomTableCell";
import { CustomTableHeaderCell } from "../../SharedComponents/CustomTableHeaderCell";
import { toast } from "react-toastify";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import Feedback from "react-bootstrap/esm/Feedback";
import { Dropdown, DropdownButton, Form, InputGroup } from "react-bootstrap";

const { Column, HeaderCell, Cell } = Table;
const colors = ["pink", "grey", "blue", "yellow", "purple", "green", "red"];

export const ManagerFeedBackView = ({ name, designation, department }: any) => {
  const [MgrFdbk, setMgrFdbk] = useState(new FeedBackVM());

  const [cachedEmployeesList, setCachedEmployeesList] = useState(
    new Array<FeedBackVM>()
  );
  const [sortColumn, setSortColumn] = useState();
  const [date, setDate] = useState();

  const [isLoading, setLoading] = useState(true);
  const [sortType, setSortType] = useState();
  const [displaySubmit, setDisplaySubmit] = useState(false);
  const [change, setChange] = useState(false);
  const [changeCmnt, setChangeCmnt] = useState(false);
  const [searchby, setSearchBy] = useState("Dropdown");
  const [searchby2, setSearchBy2] = useState("Dropdown");
  const [month, setMonth] = useState(false);
  const [green, setGreen] = useState(false);

  const [ID, setID] = useState();

  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(15);
  const [filteredEmployeesList, setFilteredEmployeesList] = useState(
    new Array<FeedBackVM>()
  );
  const [loginid, setLoginid] = useState(GetUserLoginID());
  const [searching, setSearching] = useState(false);
  const [input, setInput] = useState(false);

  useEffect(() => {
    var year = "";

    if (date == null) {
      year = totalyear;
    } else {
      year = date;
    }
    getManagerFeedBackList(totalyear, loginid);
  }, []);

  const handleFilterData = (val: string, e: any) => {
    let searchText = val;
    setPage(1);
    if (searchText) {
      setFilteredEmployeesList(
        filteredEmployeesList.filter((e) =>
          JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setSearching(true);
    } else {
      setFilteredEmployeesList([...cachedEmployeesList]);
      setSearching(false);
    }
  };
  const SearchBy = (value: any) => {
    setSearchBy(value);
  };

  const tableDataFeed = filteredEmployeesList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const getManagerFeedBackList = (year: any, loginid: any) => {
    Object.assign(MgrFdbk, { FeedBack: 0 });
    Object.assign(MgrFdbk, { Comments: " " });
    ProfileDB.GetFeedBackScreen(year, loginid)
      .then((res) => {
        if (res.data) {
          setCachedEmployeesList(res.data);

          setFilteredEmployeesList(res.data);

          setLoading(false);

          if (res.data.FeedBackYear1 == null) {
            setDisplaySubmit(false);
          } else {
            setDisplaySubmit(true);
          }
        }
      })
      .catch((err) => {
        console.log("fail");
      });
  };

  const handleSubmit = (event: FeedBackVM) => {
    Object.assign(MgrFdbk, {
      EmployeeOfficeBadgeId: event.EmployeeOfficeBadgeId,
    });
    change
      ? Object.assign(MgrFdbk, { FeedBack: event.FeedBack })
      : Object.assign(MgrFdbk, { FeedBack: 0 });
    changeCmnt
      ? Object.assign(MgrFdbk, { Comments: event.Comments })
      : Object.assign(MgrFdbk, { Comments: "" });
    setDisplaySubmit(false);
    Object.assign(MgrFdbk, {
      EmployeeOfficeBadgeId: event.EmployeeOfficeBadgeId,
    });
    if (MgrFdbk.FeedBackYear == "") {
      toast.error("Select Month");
      setMonth(true);
    } else if (MgrFdbk.FeedBackYear.split("-").join("/") > totalyear) {
      toast.error("Date cannot exceed current date");
    } else if (MgrFdbk.FeedBack > 0.5) {
      toast.error("FeedBack cannot exceed 0.5");
    } else
      ProfileDB.ManagerFeedBack(MgrFdbk, loginid).then((result) => {
        if (result.data == 1) {
          setGreen(true);

          setDisplaySubmit(false);
          getManagerFeedBackList(MgrFdbk.FeedBackYear, loginid);

          toast.success("Added successfully");
          setChange(false);
          setChangeCmnt(false);
          setGreen(false);
          Object.assign(MgrFdbk, { FeedBack: 0 });
          Object.assign(MgrFdbk, { Comments: " " });
        } else toast.error("error");
      });
  };
  const handleEdit = (event: any) => {
    setMgrFdbk(event);

    setID(event.ID);
    setDisplaySubmit(true);
  };

  const handleChange = (event: any, rowData: any) => {
    setChange(true);

    if (date == undefined) {
      toast.error("Enter Month");
      setMonth(true);
    } else {
      setMonth(false);
      Object.assign(rowData, { FeedBack: event.target.value });
    }
  };

  const handleChange1 = (event: any, rowData: any) => {
    setChangeCmnt(true);
    Object.assign(rowData, { Comments: event.target.value });
  };
  const handleSet = (value: any) => {
    Object.assign(MgrFdbk, { FeedBack: 0 });
    Object.assign(MgrFdbk, { Comments: " " });
    setMgrFdbk({ ...MgrFdbk, [value.target.name]: value.target.value });
    setDate(value.target.value);
    setChange(false);
    setChangeCmnt(false);

    getManagerFeedBackList(value.target.value, loginid);
  };
  const handleSet1 = (value: any) => {
    setChange(false);
    setChangeCmnt(false);

    setMgrFdbk({ ...MgrFdbk, [value.target.name]: value.target.value });
    setDate(value.target.value);
    getManagerFeedBackList(value.target.value, loginid);
    setMonth(false);
  };

  var month1 = new Date().getMonth().toString();
  var year1 = new Date().getFullYear().toString();
  var totalyear = "";
  if (new Date().getMonth() < 10) {
    month1 = "0" + new Date().getMonth();
    totalyear = year1 + "/" + month1;
  } else {
    month1 = month1;
    totalyear = year1 + "/" + month1;
  }

  const handleUpdate = (event: any) => {
    setMgrFdbk(event);
    if (event.FeedBackYear > totalyear.split("-").join("/")) {
      toast.error("Date cannot exceed current date");
    } else if (MgrFdbk.FeedBackYear > totalyear) {
      toast.error("Date cannot exceed current date");
    } else if (event.FeedBack > 0.5) {
      toast.error("FeedBack cannot exceed 0.5");
    } else if (MgrFdbk.FeedBack > 0.5) {
      toast.error("FeedBack cannot exceed 0.5");
    } else {
      input
        ? changeCmnt
          ? Object.assign(event, { Comments: "" })
          : Object.assign(event, { Comments: event.Comments })
        : Object.assign(event, { Comments: MgrFdbk.Comments });

      input
        ? change
          ? Object.assign(event, { Feedback: 0 })
          : Object.assign(event, { FeedBack: event.FeedBack })
        : Object.assign(event, { FeedBack: MgrFdbk.FeedBack });

      setMgrFdbk(event);

      setMgrFdbk(event);

      ProfileDB.FeedBackEdit(event, loginid).then((result) => {
        if (result.data == 1) {
          setDisplaySubmit(false);
          toast.success("Updated Successfully");

          getManagerFeedBackList(event.FeedBackYear, loginid);
          setChange(false);
          setChangeCmnt(false);

          Object.assign(MgrFdbk, { FeedBack: 0 });
          Object.assign(MgrFdbk, { Comments: " " });
        } else toast.error("Error");
      });
    }
  };

  const filterData = () => {
    setPage(1);
    let search1value = (document.getElementById("Search1") as HTMLInputElement)
      .value;

    setFilteredEmployeesList(
      cachedEmployeesList.filter((e) =>
        includesSearchValue(e, searchby, search1value)
      )
    );
  };
  const includesSearchValue = (
    e: FeedBackVM,
    searchBy: string,
    searchText: string
  ) => {
    switch (searchBy) {
      case "ID":
        return e.EmployeeOfficeBadgeId.toLowerCase().includes(
          searchText.toLowerCase()
        );

      case "Name":
        return e.Name.toLowerCase().includes(searchText.toLowerCase());

      case "Designation":
        return e.Designation.toLowerCase().includes(searchText.toLowerCase());

      default:
        return JSON.stringify(e)
          .toLowerCase()
          .includes(searchText.toLowerCase());
    }
  };

  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);

    if (sortColumn && sortType) {
      return filteredEmployeesList.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string" || "") {
          x = x.charCodeAt();
        }
        if (typeof y === "string" || "") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <PageHeader title="Manager Feedback" backPage="">
            <></>
          </PageHeader>
        </div>{" "}
        <div className="col-md-3">
          <InputGroup className="mb-3">
            <DropdownButton
              variant="outline-secondary"
              title={searchby}
              id="input-group-dropdown-1"
            >
              <Dropdown.Item href="#" onClick={() => SearchBy("ID")}>
                Employee ID
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("Name")}>
                Name
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("Designation")}>
                Designation
              </Dropdown.Item>

              <Dropdown.Item href="#" onClick={() => SearchBy("Dropdown")}>
                Default
              </Dropdown.Item>
            </DropdownButton>
            <Form.Control
              aria-label="Text input with dropdown button"
              id="Search1"
              onChange={(event) => filterData()}
              placeholder="Search..."
            />
          </InputGroup>
        </div>
        <div className="col-md-2">
          {!month ? (
            <input
              type="month"
              id="int"
              name="FeedBackYear"
              onChange={handleSet}
            />
          ) : (
            <input
              type="month"
              id="alerts-border"
              name="FeedBackYear"
              onChange={handleSet1}
            />
          )}
        </div>
        <div className="col-md-1">
          {searching == true ? (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(tableDataFeed)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={14}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          ) : (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(cachedEmployeesList)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={30}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          )}
        </div>
        <div className="col"></div>
        <hr />
      </div>

      <div className="show-container" bg-color="pink">
        <Table
          id="table"
          height={450}
          data={tableDataFeed}
          loading={isLoading}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortColumn}
          bordered={true}
          cellBordered={true}
          className="border border-dark mt-2"
          autoHeight={true}
          rowHeight={30}
          headerHeight={30}
        >
          <Column flexGrow={130} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"Year-Month"}>
              Year/Month
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="FeedBackYear">
              {(rowData: FeedBackVM) => {
                if (rowData.FeedBackYear === null) return <></>;
                else if (rowData.FeedBackYear !== rowData.FeedBackYear1)
                  return <></>;
                else if (rowData.ID == ID)
                  return displaySubmit ? <></> : <p>{rowData.FeedBackYear}</p>;
                else return <p>{rowData.FeedBackYear}</p>;
              }}
            </CustomTableCell>
          </Column>

          <Column flexGrow={110} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"ID"}>ID</CustomTableHeaderCell>
            <CustomTableCell
              type="text"
              name="EmployeeOfficeBadgeId"
              dataKey="EmployeeOfficeBadgeId"
            />
          </Column>

          <Column flexGrow={240} fixed sortable>
            <CustomTableHeaderCell placement={"Name"}>
              Name
            </CustomTableHeaderCell>
            <CustomTableCell type="text" name="Name" dataKey="Name" on />
          </Column>

          <Column flexGrow={300} align="center" sortable>
            <CustomTableHeaderCell placement={"Designation"}>
              Designation
            </CustomTableHeaderCell>
            <CustomTableCell
              type="text"
              name="Designation"
              dataKey="Designation"
            />
          </Column>
          <Column flexGrow={110} align="center" sortable>
            <CustomTableHeaderCell placement={"Feedback"}>
              {" "}
              Feedback
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="FeedBack">
              {(rowData: FeedBackVM) => {
                if (rowData.FeedBackYear === null)
                  return (
                    <input
                      type="number"
                      id="inputnum"
                      onChange={(event) => handleChange(event, rowData)}
                    ></input>
                  );
                else if (rowData.FeedBackYear !== rowData.FeedBackYear1)
                  return (
                    <input
                      type="number"
                      id="inputnum"
                      onChange={(event) => handleChange(event, rowData)}
                    ></input>
                  );
                else if (rowData.ID == ID)
                  return displaySubmit ? (
                    <input
                      type="number"
                      id="inputnum"
                      defaultValue={rowData.FeedBack}
                      onChange={(event) => handleChange(event, rowData)}
                    ></input>
                  ) : (
                    <p>{rowData.FeedBack}</p>
                  );
                else return <p>{rowData.FeedBack}</p>;
              }}
            </CustomTableCell>
          </Column>
          <Column flexGrow={380}>
            <CustomTableHeaderCell placement={"Comments"}>
              Comments
            </CustomTableHeaderCell>

            <CustomTableCell dataKey="Comments">
              {(rowData: FeedBackVM) => {
                if (rowData.FeedBackYear === null)
                  return (
                    <input
                      type="text"
                      id="inputtxt"
                      onChange={(event) => handleChange1(event, rowData)}
                    ></input>
                  );
                else if (rowData.FeedBackYear !== rowData.FeedBackYear1)
                  return (
                    <input
                      type="text"
                      id="inputtxt"
                      onChange={(event) => handleChange1(event, rowData)}
                    ></input>
                  );
                else if (rowData.ID == ID)
                  return displaySubmit ? (
                    <input
                      type="text"
                      id="inputtxt"
                      defaultValue={rowData.Comments}
                      onChange={(event) => handleChange1(event, rowData)}
                    ></input>
                  ) : (
                    <p>{rowData.Comments}</p>
                  );
                else return <p>{rowData.Comments}</p>;
              }}
            </CustomTableCell>
          </Column>
          <Column flexGrow={70}>
            <CustomTableHeaderCell></CustomTableHeaderCell>
            <CustomTableCell>
              {(rowData: FeedBackVM) => {
                if (rowData.FeedBackYear === null)
                  return (
                    <div className="d-flex justify-content-start align-items-center flex-row gap-4">
                      <Button onClick={() => handleSubmit(rowData)}>
                        Submit
                      </Button>
                    </div>
                  );
                else if (rowData.FeedBackYear !== rowData.FeedBackYear1)
                  return (
                    <div className="d-flex justify-content-start align-items-center flex-row gap-4">
                      <Button onClick={() => handleSubmit(rowData)}>
                        Submit
                      </Button>
                    </div>
                  );
                else if (rowData.ID == ID)
                  return displaySubmit ? (
                    <div className="d-flex justify-content-start align-items-center flex-row gap-4">
                      <Button onClick={() => handleUpdate(rowData)}>
                        Update
                      </Button>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-start align-items-center flex-row gap-4">
                      <Button onClick={() => handleEdit(rowData)}>Edit</Button>
                    </div>
                  );
                else
                  return (
                    <div className="d-flex justify-content-start align-items-center flex-row gap-4">
                      <Button onClick={() => handleEdit(rowData)}>Edit</Button>
                    </div>
                  );
              }}
            </CustomTableCell>
          </Column>
        </Table>

        {filteredEmployeesList && (
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="md"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={filteredEmployeesList.length}
              limitOptions={[10, 15, 20, 25, 30]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        )}
      </div>
    </>
  );
};
